/**
 * 5.1.3 금지 네트워크 설정 Store
 *
 * @since 2017-12-12
 * @author devp020
 */

import {fnGetCodeVal} from '~/utils/admin-common'
import {i18n} from '~/plugins/i18n'

export const state = () => ({
  // api url 목록
  apiUrl: {
    banNetUrl: '/api/pm/ban-net',
    nameUrl: '/uname/'
  },

  forbidNetworkListFilter: [],
  forbidNetworkResult: null,
  errorMessage: null
})

export const mutations = {
  // 금지 네트워크 설정 조회
  mutForbidNetwork (state, payload) {
    const arrD = []
    if (!payload) {
      state.forbidNetworkListFilter = arrD
      return
    }
    function injectIconUname (list, type) {
      _.forEach(list, (item) => {
        item['ico_type'] = type
        if (type === 5 && !_.isUndefined(item.policy_mng_int_net_uname)) {
          item['uname'] = `${item.policy_mng_int_net_uname}`
        } else if (type > 5) {
          item['uname'] = `${item.policy_mng_ban_net_str_filter_uname}`
        } else if (!_.isUndefined(item.policy_mng_ban_net_ip_exp)) {
          item['uname'] = `${item.policy_mng_ban_net_ip_exp}`
        }
      })
    }

    _.forEach(payload, (d) => {
      const addD = {..._.clone(d), prtc: [], src_port: [], dst_port: []}
      const srcType = addD.policy_mng_ban_net_src_type
      if (srcType < 4) {
        const str = (srcType === 2) ? ` (${i18n.t('cmn.internalNetwork')})` : (srcType === 3) ? ` (${i18n.t('cmn.externalNetwork')})` : ''
        addD.policy_mng_ban_net_src = [ {uname: `ANY${str}`, ico_type: ''} ]
      } else {
        injectIconUname(addD.policy_mng_ban_net_src, srcType)
      }

      const dstType = addD.policy_mng_ban_net_dst_type
      if (dstType < 4) {
        const str = (dstType === 2) ? ` (${i18n.t('cmn.internalNetwork')})` : (dstType === 3) ? ` (${i18n.t('cmn.externalNetwork')})` : ''
        addD.policy_mng_ban_net_dst = [ {uname: `ANY${str}`, ico_type: ''} ]
      } else {
        injectIconUname(addD.policy_mng_ban_net_dst, dstType)
      }

      if (addD.ban_net_service.length > 0) {
        _.forEach(addD.ban_net_service, (objVal) => {
          const srcTxt = objVal['policy_mng_ban_net_srv_src_port_exp']
          const dstTxt = objVal['policy_mng_ban_net_srv_dst_port_exp']
          addD.prtc.push(fnGetCodeVal('net_srv_prtc', objVal['policy_mng_ban_net_srv_prtc']))
          addD.src_port.push((srcTxt === '*' || srcTxt.trim() === '') ? 'ANY' : srcTxt)
          addD.dst_port.push((dstTxt === '*' || dstTxt.trim() === '') ? 'ANY' : dstTxt)
        })
      } else {
        addD.prtc.push('ANY')
        addD.src_port.push('ANY')
        addD.dst_port.push('ANY')
      }

      addD['appTmpD'] = _.clone(addD.application)
      if (addD.application.length === 0) addD.appTmpD.push({policy_mng_ban_net_str_filter_uname: 'ANY'})
      arrD.push(addD)
    })
    state.forbidNetworkListFilter = arrD
  },
  mutationErrorMessage (state, payload) {
    state.errorMessage = payload
  },
  setGetListDataDefault (state) {
    state.forbidNetworkList = []
    state.forbidNetworkListFilter = []
  }
}

export const actions = {
  // 금지 네트워크 설정 조회
  async acsForbidNetwork ({commit, state}, payload = 0) {
    try {
      const res = await this.$axios.$get(`${state.apiUrl.banNetUrl}/${payload}`)
      if (res.code === 'ok') {
        commit('mutForbidNetwork', res.result)
      } else {
        commit('mutForbidNetwork', [])
      }
    } catch (error) {
      commit('mutationErrorMessage', error)
    }
  },
  // 금지 네트워크 이름 중복 확인 조회
  async getForbidNetworkNameCnt ({commit, state}, name = '') {
    try {
      const res = await this.$axios.$get(`${state.apiUrl.banNetUrl}${state.apiUrl.nameUrl}${name}`)
      if (res.code === 'ok' && res.result.msg !== undefined) {
        res.result.cnt = res.result.msg
      }
      return res
    } catch (e) {
      return {code: 'nok', reason: e}
    }
  },
  // 금지네트워크 빈설정 추가
  async addForbidNetworkSpare ({state}) {
    try {
      const result = await this.$axios.$post(`${state.apiUrl.banNetUrl}`, null, {loading: false, successAlert: false})
      if (result.code === 'ok' && result.result.msg !== undefined) {
        result.result.policy_mng_ban_net_id = result.result.msg
      }
      return result
    } catch (e) {
      return {code: 'nok', reason: e}
    }
  },
  // 금지네트워크 빈설정 수정 (기본 설정 수정)
  async editForbidNetworkSpare ({state, dispatch}, editParam) {
    try {
      const param = {
        policy_mng_ban_net_id: editParam.policy_mng_ban_net_id,
        policy_mng_ban_net_uname: editParam.policy_mng_ban_net_uname,
        policy_mng_ban_net_bidir_yn: editParam.policy_mng_ban_net_bidir_yn,
        policy_mng_ban_net_desc: editParam.policy_mng_ban_net_desc,
        policy_mng_ban_net_src_type: editParam.policy_mng_ban_net_src_type,
        policy_mng_ban_net_dst_type: editParam.policy_mng_ban_net_dst_type
      }
      const result = await this.$axios.$put(`${state.apiUrl.banNetUrl}`, param, {loading: false, successAlert: false})
      if (result.code === 'ok') {
        // dispatch('acsForbidNetwork')
      }
      return result
    } catch (e) {
      return {code: 'nok', reason: e}
    }
  },

  // 금지네트워크 삭제
  async removeForbidNetwork ({state}, idList) {
    try {
      const result = await this.$axios.$put(`${state.apiUrl.banNetUrl}/multi`, {policy_mng_ban_net_id_list: idList}, {loading: false, successAlert: false})
      if (result.code !== 'ok') return result
      _.forEach(idList, (id) => {
        const findIdx = _.findIndex(state.forbidNetworkListFilter, (data) => {
          return data.policy_mng_ban_net_id === id
        })
        if (findIdx !== -1) {
          state.forbidNetworkListFilter.splice(findIdx, 1)
        }
      })
      return result
    } catch (e) {
      return {code: 'nok', reason: e}
    }
  },

  async applyForbidNetwork ({state}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$put(`${state.apiUrl.banNetUrl}/apply`, null, {loading: false, applyMsg: true})
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async cancelForbidNetwork ({state, dispatch}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$put(`${state.apiUrl.banNetUrl}/cancel`, null, {loading: false, cancelMsg: true})
      dispatch('acsForbidNetwork')
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  }
}
export const getters = {}
export const strict = false
